import { useSuspenseQuery } from "@apollo/client/react";
import {
  GetEvidencesModelContextDocument,
  type GetEvidencesModelContextQuery,
  type GetEvidencesModelContextQueryVariables,
} from "~/features/evidences/gqls";
import { useTenant } from "~/features/tenant/context";

/** Lookup data for the search sidebar: references (the only preloaded option list). */
export function useEvidenceModelContext() {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  const { data } = useSuspenseQuery<GetEvidencesModelContextQuery, GetEvidencesModelContextQueryVariables>(
    GetEvidencesModelContextDocument,
    { variables: { tenantId } },
  );
  return { references: data.references };
}
